import React from 'react';
import { XOctagon } from 'lucide-react';
export function FailedAttemptsSection() {
  const failures = [{
    title: 'Jugar los títulos más masivos',
    desc: 'Te hace invisible; eres una aguja en un pajar de 50,000 canales gigantes en Fortnite o Warzone.'
  }, {
    title: 'Spamear tu link en grupos',
    desc: "No funciona porque todos en esos grupos de 'apoyo' quieren ser vistos, nadie quiere ver."
  }, {
    title: 'Esperar al algoritmo',
    desc: 'Esperar que el algoritmo de Twitch te descubra es como esperar ganar la lotería sin comprar el boleto.'
  }, {
    title: 'Comprar equipo profesional',
    desc: 'Pensar que la cámara atrae gente es un error; la gente se queda por la conexión, no por la resolución.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gaming-bg relative" data-id="element-21">
      <div className="max-w-5xl mx-auto" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <h2 className="font-orbitron text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-24">
            Por qué lo que has intentado{' '}
            <span className="text-red-500" data-id="element-25">NO FUNCIONA</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-26">
            Estás atrapado en el ciclo del creador frustrado siguiendo consejos
            obsoletos de 2018.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-27">
          {failures.map((item, index) => <div key={index} className="flex items-start p-6 bg-gaming-card border border-red-900/30 rounded-lg hover:border-red-500/50 transition-colors group" data-id="element-28">
              <div className="flex-shrink-0 mr-4" data-id="element-29">
                <XOctagon className="w-8 h-8 text-red-500 group-hover:scale-110 transition-transform" data-id="element-30" />
              </div>
              <div data-id="element-31">
                <h3 className="text-white font-orbitron font-bold text-lg mb-2" data-id="element-32">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-33">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}